"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DnsproveStatusCode = exports.CodedError = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let DnsproveStatusCode = exports.DnsproveStatusCode = void 0;
(function (DnsproveStatusCode) {
  DnsproveStatusCode[DnsproveStatusCode["IDNS_QUERY_ERROR_GENERAL"] = 0] = "IDNS_QUERY_ERROR_GENERAL";
})(DnsproveStatusCode || (exports.DnsproveStatusCode = DnsproveStatusCode = {}));
class CodedError extends Error {
  constructor(message, code, codeString) {
    super(message);
    _defineProperty(this, "code", void 0);
    _defineProperty(this, "codeString", void 0);
    this.code = code;
    this.codeString = codeString;
  }
}
exports.CodedError = CodedError;